import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "h-50 pl-15 flex items-center bg-theme text-white text-15" }
const _hoisted_2 = { class: "p-15 border-t" }
const _hoisted_3 = { class: "p-15 border-t" }
const _hoisted_4 = { class: "text-default text-16" }
const _hoisted_5 = { class: "bg-theme2 text-theme text-16 h-40 flex items-center justify-center mt-10" }
const _hoisted_6 = ["data-clipboard-text"]
const _hoisted_7 = { class: "p-15 border-t" }
const _hoisted_8 = { class: "p-15 border-t" }
const _hoisted_9 = { class: "p-15 border-t" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DetailItem = _resolveComponent("DetailItem")!
  const _component_DetailBlockItem = _resolveComponent("DetailBlockItem")!
  const _component_FooterButton = _resolveComponent("FooterButton")!
  const _component_approver = _resolveComponent("approver")!

  return (_ctx.detail)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["bg-page", _ctx.detail && _ctx.detail.opt_lists.length ? 'pb-98' : 'pb-20'])
      }, [
        _createElementVNode("div", _hoisted_1, "审批状态：" + _toDisplayString(_ctx.detail.state_name), 1),
        _createVNode(_component_DetailBlockItem, {
          title: "基本信息",
          class: "bg-white mb-8"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_DetailItem, {
                label: "申请编号：",
                value: _ctx.detail.code
              }, null, 8, ["value"]),
              _createVNode(_component_DetailItem, {
                label: "发起时间：",
                value: _ctx.detail.create_date
              }, null, 8, ["value"]),
              _createVNode(_component_DetailItem, {
                label: "发起人：",
                isBlue: true,
                value: `${_ctx.detail.user_info?.department_name}-${_ctx.detail.user_info?.name}`
              }, null, 8, ["value"])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_DetailBlockItem, {
          title: "来访人信息",
          class: "bg-white mb-8"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.detail.person_lists, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: item.key,
                  class: "mb-15 border-dashed-b"
                }, [
                  _createVNode(_component_DetailItem, {
                    label: "姓名：",
                    value: item.name
                  }, null, 8, ["value"]),
                  _createVNode(_component_DetailItem, {
                    label: "手机号：",
                    value: item.mobile
                  }, null, 8, ["value"]),
                  _createVNode(_component_DetailItem, {
                    label: "邮箱：",
                    value: item.email
                  }, null, 8, ["value"]),
                  _createVNode(_component_DetailItem, {
                    label: "车牌号：",
                    value: item.car_number
                  }, null, 8, ["value"])
                ]))
              }), 128)),
              (_ctx.detail.person_num != '0')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("div", _hoisted_4, "总需填写人数：" + _toDisplayString(_ctx.detail.person_num) + "人", 1),
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("div", {
                        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.copyCurrentUrl && _ctx.copyCurrentUrl(...args))),
                        class: "copy-view",
                        "data-clipboard-text": _ctx.copyText
                      }, " 复制来访人信息填写链接 ", 8, _hoisted_6)
                    ])
                  ], 64))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_DetailBlockItem, {
          title: "访问信息",
          class: "bg-white mb-8"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_DetailItem, {
                label: "来访原因：",
                value: _ctx.detail.person_reason
              }, null, 8, ["value"]),
              _createVNode(_component_DetailItem, {
                label: "来访日期：",
                value: _ctx.detail.person_date
              }, null, 8, ["value"]),
              _createVNode(_component_DetailItem, {
                label: "来访时间：",
                value: _ctx.detail.person_time
              }, null, 8, ["value"])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_DetailBlockItem, {
          title: "被访人信息",
          class: "bg-white mb-8"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_DetailItem, {
                label: "被访对象：",
                value: _ctx.detail.visit_stores_name
              }, null, 8, ["value"]),
              _createVNode(_component_DetailItem, {
                label: "被访人：",
                value: _ctx.detail.visit_user_name
              }, null, 8, ["value"]),
              _createVNode(_component_DetailItem, {
                label: "被访人手机号：",
                value: _ctx.detail.visit_user_mobile
              }, null, 8, ["value"]),
              _createVNode(_component_DetailItem, {
                label: "被访人邮箱：",
                value: _ctx.detail.visit_user_email
              }, null, 8, ["value"])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_DetailBlockItem, {
          title: "更多信息",
          class: "bg-white"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_9, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.detail.visit_diy_field, (item) => {
                return (_openBlock(), _createBlock(_component_DetailItem, {
                  key: item.id,
                  label: `${item.title}：`,
                  value: item.content
                }, null, 8, ["label", "value"]))
              }), 128))
            ])
          ]),
          _: 1
        }),
        (_ctx.detail.opt_lists?.length)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (_ctx.detail.opt_lists.length === 2)
                ? (_openBlock(), _createBlock(_component_FooterButton, {
                    key: 0,
                    cancelText: "拒绝",
                    okText: "通过",
                    onCancel: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleClick('2'))),
                    onSubmit: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleClick('1')))
                  }))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    (_ctx.detail.opt_lists[0].type == '1')
                      ? (_openBlock(), _createBlock(_component_FooterButton, {
                          key: 0,
                          showCancel: true,
                          showOk: false,
                          cancelText: "拒绝",
                          onCancel: _cache[3] || (_cache[3] = ($event: any) => (_ctx.handleClick('2')))
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.detail.opt_lists[0].type == '2')
                      ? (_openBlock(), _createBlock(_component_FooterButton, {
                          key: 1,
                          showCancel: false,
                          okText: "通过",
                          onSubmit: _cache[4] || (_cache[4] = ($event: any) => (_ctx.handleClick('1')))
                        }))
                      : _createCommentVNode("", true)
                  ], 64))
            ], 64))
          : _createCommentVNode("", true),
        _createVNode(_component_approver, {
          show: _ctx.show,
          "onUpdate:show": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.show) = $event)),
          listData: _ctx.detail.approval_uids_arr
        }, null, 8, ["show", "listData"])
      ], 2))
    : _createCommentVNode("", true)
}